import { Injectable } from "@angular/core";
import { BasicResponse } from "src/app/core/models/basic-response.model";
import { getConnection } from "src/app/core/services/functions.service";
import { QueriesService } from "src/app/core/services/queries.service";

@Injectable({
    providedIn: 'root'
})
export class AcuerdoPagoService {
    constructor(private queriesService: QueriesService,) {
    
    }

    async buscarCuenta(n_ide: string, cue: string): Promise<BasicResponse>{
        const bloque = await this.getBloqueRedondeo('c.saldo_ven * 0.1');
        console.log(`SELECT (select NOM from nits WHERE C_EMP = c.C_EMP AND N_IDE = c.N_IDE) NOM, (SELECT SUM(CAPITAL) FROM CART_DET WHERE C_EMP=c.C_EMP AND C_AGR=c.C_AGR AND T_CRE=c.T_CRE AND CUE=c.CUE) CAPITAL_TOTAL, (SELECT COUNT(*) FROM CART_DET WHERE C_EMP=c.C_EMP AND C_AGR=c.C_AGR AND T_CRE=c.T_CRE AND CUE=c.CUE AND FUE = 'CU') CUOTAS, ${bloque} saldo_ini_venc, c.* FROM CART_ENC c WHERE C_EMP = '${getConnection()}' AND N_IDE = '${n_ide}' AND CUE = '${cue}'`);
        const result = await this.queriesService.query(`SELECT (select NOM from nits WHERE C_EMP = c.C_EMP AND N_IDE = c.N_IDE) NOM, (SELECT SUM(CAPITAL) FROM CART_DET WHERE C_EMP=c.C_EMP AND C_AGR=c.C_AGR AND T_CRE=c.T_CRE AND CUE=c.CUE) CAPITAL_TOTAL, (SELECT COUNT(*) FROM CART_DET WHERE C_EMP=c.C_EMP AND C_AGR=c.C_AGR AND T_CRE=c.T_CRE AND CUE=c.CUE AND FUE = 'CU') CUOTAS, ${bloque} saldo_ini_venc, c.* FROM CART_ENC c WHERE C_EMP = '${getConnection()}' AND N_IDE = '${n_ide}' AND CUE = '${cue}'`.trim()).execute()
        if(result.success){
            if(result.data.length == 0) {
                result.success = false;
            }
        }
        return result;
    }

    async getPlazos(min: number, max: number): Promise<BasicResponse> {
        const result = await this.queriesService.query(`Select * From param_mod_fin Where c_emp='${getConnection()}' And cuota_ini Is Not Null And tipo = 'EA' And cuota_ini BETWEEN ${min} AND ${max} Order By to_number(cuota_ini)`.trim()).execute();
        return result;
    }

    async simulacion(cuotas, capital){
        
    }

    async getBloqueRedondeo(value: string): Promise<string> {
        return ` Round(${value},(Select 
        Nvl(Valor_Parametro, 2)
        From Parametros_Sicf s
       Where S.C_Emp = '${getConnection()}'
         And Codigo_Modulo = '0001'
         And Codigo_Parametro = 'REDONDEO_SAP')) `
    }
}